import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterSelect } from './filters/lightbox_filter_select';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';

function LightboxAdditional(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.ADDITIONAL_VIEW];
    const vehicleTypeTranslationKey = FilterLabelTranslationKeys[Filters.VEHICLE_TYPE];

    return (
        <LightboxView
            viewName={FilterSections.ADDITIONAL_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <LightboxFilterSelect
                    name={Filters.VEHICLE_TYPE}
                    value={props.vehicleTypeValue}
                    options={props.vehicleTypeOptions}
                    labelTranslationKey={vehicleTypeTranslationKey}
                    provideAllTranslationKey={'catalog-filters-vehicle-type-select-label-all'}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={!props.vehicleTypeValue}
                />
            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
            />
        </LightboxView>
    );
}

LightboxAdditional.propTypes = {
    vehicleTypeValue: PropTypes.string.isRequired,
    vehicleTypeOptions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxAdditional };
